import React, { Component } from 'react';
import './evaluation-report.scss';
import { ImageConstants, Constants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import WronglyAnswered from '../../../common/wrong-answers-modal/wrong-answers-modalV1/wrong-answers-modal'
import HomeworkApi from '../../../../apis/homework'
import Loading from '../../../../components/common/loading/loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import StudentDetailReport from '../student-level-report/student-detail/student-detail'


class HomeworkEvalutionReport extends Component {
    state = {
        noviceUsers: [
        ],
        types: [
            {
                title: "Novice",
                threshold: "< 50%",
                color: "#8B8BF6",
                mark: "30%" //for demo only
            },
            {
                title: "Proficient",
                threshold: "50%-80%",
                color: "#FFBB7C",
                mark: "60%"
            },
            {
                title: "Advance",
                threshold: "> 80%",
                color: "#80D2F4",
                mark: "90%"
            }
        ]
    }


    selectedItem = {}

    constructor(props) {
        super(props) 

        let chapters = []

        chapters.push(this.props.match.params?.chapter)

        this.selectedItem = {
            class : this.props.match.params?.class,
            chapters :  chapters,
            createdDate : this.props.match.params?.createdDate
        }

        console.log(this.selectedItem)


    }




    componentDidMount() {

            

        this.getHomeworkEvaluationReport()
        document.addEventListener('mousedown', this.handleClickEvent, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    handleClickEvent = (event) => {
        if (this.studentRef && !this.studentRef.contains(event.target)) {
            this.setState({ showNotCompletedList: false })
        }
    }

    onClickStudent(user) {


        this.setState({showReport : true, selectedStudent : user, selectedHomework : {_id:this.props.match.params.homeworkId}})
        //this.props.onClickStudent && this.props.onClickStudent(user)
    }

    getHomeworkEvaluationReport(payload = {}) {

        // if (payload.page) payload.page = 1
        // if (payload.page) payload.limit = this.limit
        // payload.type = this.props.type

        if (this.props.match.params.homeworkId) {
            payload.homeworkId = this.props.match.params.homeworkId
        }

        this.setState({ isLoading: true })

        HomeworkApi.getHomeworkEvaluationReport(payload)
            .then(response => {

                this.setState(
                    {
                        noviceStudents: response.noviceStudents,
                        proficientStudents: response.proficientStudents,
                        advancedStudents: response.advancedStudents,
                        notCompletedStudents: response.notCompletedStudents,
                        isLoading: false
                    })

            }).catch(err => {
            })
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb ml-5 bg-color'>
                <span>{this.selectedItem.class}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{`${this.selectedItem.chapters[0]} >`}</span>
                <span className='active pl-2'>{this.getDate(this.selectedItem.createdDate)}</span>
            </div>
        )
    }

    onClickBack = () => {

        this.setState({showReport:false})
        
        //this.props.delegate && this.props.delegate.hideReport && this.props.delegate.hideReport()
    }

    onClickReportCardInfo = (type, students) => {

        let userIds = []

        for (let i = 0; i < students.length; i++) {
            userIds.push(students[i].userId)
        }

        this.setState({ showWrongAnswersReport: true, userIds, selectedStatus: type })
    }

    hideReport = () => {
        this.setState({ showWrongAnswersReport: false })
    }
    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    onClickNotCompleted = () => {
        this.setState({ showNotCompletedList: true })
    }

    closeStudents() {
        this.setState({ showNotCompletedList: false })
    }

    renderStudentCard() {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {this.state.notCompletedStudents?.length ? this.state.notCompletedStudents?.map((item, index) =>
                    <div className='px-4 py-2 row align-items-center'>
                        <div className="profile-avatar text-center mr-2 d-inline-block">
                            <div className="row justify-content-center">
                                {item.image ? <img className="" alt="img" src={`${item.basePath}${item.image}`} />
                                    :
                                    <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                            </div>
                        </div>
                        <div className='student-name ml-2'>
                            {item.name}
                        </div>
                    </div>

                )
                    :
                    <div className="text-center pt-4">No Records Found</div>
                }
            </div>
        )
    }


    

    render() {


        if(this.state.showWrongAnswersReport) {
            return <WronglyAnswered show={this.state.showWrongAnswersReport} 
                        delegate={this} onClose={this.hideReport} 
                        userIds={this.state.userIds} 
                        selectedStatus={this.state.selectedStatus} 
                        homeworkId={this.props.match.params.homeworkId}
                        selectedItem = {{...this.selectedItem}}
                        />
        }

        if (this.state.showReport) {
                return <StudentDetailReport type={this.props.match.params.type} 
                delegate={this} selectedItem={this.state.selectedHomework} 
                student={this.state.selectedStudent} 
                onClickBack = {this.onClickBack}
                selectedData = {this.selectedItem?{...this.selectedItem} : ''}
            />
        }



        return (
            <>
                {this.state.isLoading && <div ><Loading> </Loading></div>}
                <div className='homework-evaluation-report'>

                    {/* <div className='mb-5'>
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div> */}

                    <div className='container-1'>
                    {/* <div className='mb-3 item1' >
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div> */}
                    <div className='item-2'>
                    <span className='screen-title title-center my-5'>Homework Evaluation Report</span>
                    </div>
                    </div>

                    <span>{this.renderBreadcrumb()}</span>

                    <div className="text-right pt-4 mr-4 position-relative">
                        <span className="text-danger  cursor-pointer" onClick={this.onClickNotCompleted}><FontAwesomeIcon icon={faTimesCircle} /> Not Completed <span className="not-completed text-primary">{this.state?.notCompletedStudents?.length || 0} Students</span></span>
                        {this.state.showNotCompletedList ? this.renderStudentCard() : ""}
                    </div>
                    <div className='pt-2 report-card-wrapper ml-3'>
                        <div className='report-card novice-border'>
                            <div className='report-card-header' style={{ backgroundColor: '#8B8BF6' }}>
                                <div className='row header-items'>
                                    <div className='col-7 text-center'>
                                        <span><span className='header-title'>Novice</span> | <strong>{'< 50 %'}</strong></span>
                                    </div>
                                    {this.state.noviceStudents && this.state.noviceStudents.length ? <div className='col-4 text-right mr-2'>
                                        <img className='info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo('NOVICE', this.state.noviceStudents)} />
                                    </div>
                                        :
                                        <></>}
                                </div>
                            </div>

                            <div className='report-card-body'>

                                {this.state.noviceStudents && this.state.noviceStudents.length ? this.state.noviceStudents.map((user, index) => (
                                    <div className='row mt-4'>
                                        <div className='col-2 pr-0 my-auto'>
                                            <div className='user-image'>
                                                {user.image ? <img className="user-image" alt="img" src={`${user.basePath}${user.image}`} />
                                                    :
                                                    <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                            </div>
                                        </div>
                                        <div className='col my-auto cursor-pointer' onClick={() => this.onClickStudent(user)}>
                                            <span className='user-name'>{user.name}</span>
                                            <span className=" marks pl-2">( Marks: {user.mark}%)</span>
                                            <img className="right-arrow  pt-1" src={getImageSource(ImageConstants.RIGHT_ARROW_GRAY1)} />

                                        </div>
                                    </div>
                                ))
                                    :

                                    <div className="no-data text-center">
                                        <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                        <div className="empty">This is Empty</div>
                                        <div className="no-student">No Student in this bucket</div>
                                    </div>
                                }

                            </div>
                        </div>
                        <div className='report-card proficient-border'>
                            <div className='report-card-header' style={{ backgroundColor: "#FFBB7C" }}>
                                <div className='row header-items'>
                                    <div className='col-7 text-center'>
                                        <span><span className='header-title'>Proficient</span> | <strong>{'50%-80%'}</strong></span>
                                    </div>
                                    {this.state.proficientStudents && this.state.proficientStudents.length ? <div className='col-4 text-right mr-2'>
                                        <img className='info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo('PROFICIENT', this.state.proficientStudents)} />
                                    </div>
                                        :
                                        <></>}
                                </div>
                            </div>

                            <div className='report-card-body'>

                                {this.state.proficientStudents && this.state.proficientStudents.length ? this.state.proficientStudents.map((user, index) => (
                                    <div className='row mt-4'>
                                        <div className='col-2 pr-0 my-auto'>
                                            <div className='user-image'>
                                                {user.image ? <img className="user-image" alt="img" src={`${user.basePath}${user.image}`} />
                                                    :
                                                    <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                            </div>
                                        </div>
                                        <div className='col my-auto cursor-pointer' onClick={() => this.onClickStudent(user)}>
                                            <span className='user-name'>{user.name}</span>
                                            <span className=" marks pl-2">( Marks: {user.mark}%)</span>
                                            <img className="right-arrow  pt-1" src={getImageSource(ImageConstants.RIGHT_ARROW_GRAY1)} />
                                        </div>
                                    </div>
                                ))
                                    :

                                    <div className="no-data text-center">
                                        <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                        <div className="empty">This is Empty</div>
                                        <div className="no-student">No Student in this bucket</div>
                                    </div>
                                }

                            </div>
                        </div>
                        <div className='report-card advance-border'>
                            <div className='report-card-header' style={{ backgroundColor: "#80D2F4" }}>
                                <div className='row header-items'>
                                    <div className='col-7 text-center'>
                                        <span><span className='header-title'>Advance</span> | <strong>{"> 80 %"}</strong></span>
                                    </div>
                                    {this.state.advancedStudents && this.state.advancedStudents.length ? <div className='col-4 text-right mr-2'>
                                        <img className='info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo('ADVANCE', this.state.advancedStudents)} />

                                    </div>
                                        :
                                        <></>}
                                </div>
                            </div>

                            <div className='report-card-body'>

                                {this.state.advancedStudents && this.state.advancedStudents.length ? this.state.advancedStudents.map((user, index) => (
                                    <div className='row mt-4'>
                                        <div className='col-2 pr-0 my-auto'>
                                            <div className='user-image'>
                                                {/* <img className='user-image' src={'https://countingwell-doubts-assets-dev.s3.ap-south-1.amazonaws.com/366a7097-1ebe-4fc7-9c02-15eb91b53d49-user%20image.png'} /> */}
                                                {user.image ? <img className="user-image" alt="img" src={`${user.basePath}${user.image}`} />
                                                    :
                                                    <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                            </div>
                                        </div>
                                        <div className='col my-auto cursor-pointer' onClick={() => this.onClickStudent(user)}>
                                            <span className='user-name'>{user.name}</span>
                                            <span className=" marks pl-2">( Marks: {user.mark}%)</span>
                                            <img className="right-arrow  pt-1" src={getImageSource(ImageConstants.RIGHT_ARROW_GRAY1)} />

                                        </div>
                                    </div>

                                ))
                                    :
                                    <div className="no-data text-center">
                                        <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                        <div className="empty">This is Empty</div>
                                        <div className="no-student">No Student in this bucket</div>
                                    </div>
                                }

                            </div>
                        </div>
                        {/* ))} */}
                    </div>
                    {/* {this.state.showWrongAnswersReport && <WronglyAnswered show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport} userIds={this.state.userIds} selectedStatus={this.state.selectedStatus} homeworkId={this.props.selectedItem?._id} />} */}
                </div >
            </>);
    }
}

export default HomeworkEvalutionReport;